export const BASE_LANGUAGE = 'cs';
export const BASE_LANGUAGE_LABEL = 'Čeština';
export const ENGLISH_LANGUAGE_CODE = 'en';

export const LANGUAGE_LABEL_SEPARATOR = '|';
